import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Stack,
	Typography
} from "@mui/material";
import { Box } from "@mui/system";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as Mobile } from "../../Assets/Icons/MobileIcon.svg";
import { ReactComponent as PC } from "../../Assets/Icons/PcIcon.svg";
import LandingAnimation from "../../Helpers/LandingAnimation";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";
import { BackdropLoading } from "../Common/BackdropLoading";
import BigButton from "../Common/BigButton";
import { UserContext } from "../UserContext";

export const UserManualContent = () => {
	const [loading, setLoading] = useState(true);
	const [q, set_q] = useState([]);
	const { ApiCall } = useContext(ApiContext);
	const { handleTitle } = useContext(UserContext);

	const { t } = useTranslation();

	useEffect(() => {
		handleTitle(t("common.support"));
		setLoading(true);
		ApiCall("GET", "faq")
			.then((qs) => {
				set_q(qs);
			})
			.catch((error) => {
				console.log(error);
			})
			.finally(() => {
				setLoading(false);
			});
	}, []);

	function linkRow(urlFin, urlEng) {
		return (
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					maxWidth: "350px",
					justifyContent: "space-between",
				}}
			>
				<BigButton
					text={t("user_manuals.in_finnish")}
					backgroundColor={ColorScheme.primary}
					action={() => window.open(urlFin, "_blank")}
					borderColor={ColorScheme.primary}
					width={"48%"}
				/>
				<BigButton
					text={t("user_manuals.in_english")}
					backgroundColor={ColorScheme.primary}
					action={() => window.open(urlEng, "_blank")}
					borderColor={ColorScheme.primary}
					width={"48%"}
				/>
			</Box>
		);
	}

	function titleRow(title, type) {
		return (
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					cursor: "pointer"
				}}
			>
				<Box
					sx={{
						backgroundColor:
							type !== 1
								? ColorScheme.primary
								: ColorScheme.background,
						justifyContent: "center",
						alignItems: "center",
						display: "flex",
						marginRight: "20px",
						padding: "5px",
						borderRadius: "4px"
					}}
				>
					{type === 1 ? (
						<Mobile
							stroke={ColorScheme.secondary}
							width={"25px"}
							height={"25px"}
							strokeWidth={"1.5px"}
						/>
					) : (
						<PC
							stroke={ColorScheme.secondary}
							width={"25px"}
							height={"25px"}
							strokeWidth={"2px"}
						/>
					)}
				</Box>
				<Typography sx={{ marginTop: "2px", fontWeight: "700" }}>
					{title}
				</Typography>
			</Box>
		);
	}

	return (
		<Box>
			{loading ? (
				<BackdropLoading />
			) : (
				<LandingAnimation>
					<Stack>
						<Typography
							variant={"h5"}
							sx={{ marginBottom: "20px" }}
						>
							{t("user_manuals.user_manuals") + ":"}
						</Typography>
						<Stack>
							<Accordion sx={{
								"&:hover": { backgroundColor: ColorScheme.secondary + ColorScheme.opacity90 },
							 }}>
								<AccordionSummary>
									{titleRow(
										t("user_manuals.tologo_introduction"),
										1
									)}
								</AccordionSummary>
								<AccordionDetails>
									{linkRow(
										"https://drive.google.com/file/d/1mchmH5T8TDo0T0jOJloUtYyPxKN_JfD8/view?usp=share_link",
										"https://drive.google.com/file/d/1SXBzCx7EkiUKvM9gkfv0cekAymxNy6jd/view?usp=share_link"
									)}
								</AccordionDetails>
							</Accordion>

							<Accordion sx={{
								"&:hover": { backgroundColor: ColorScheme.secondary + ColorScheme.opacity90 },
							 }}>
								<AccordionSummary>
									{titleRow(
										t("user_manuals.tologo_access"),
										1
									)}
								</AccordionSummary>
								<AccordionDetails>
									{linkRow(
										"https://drive.google.com/file/d/16Dzcgs67sT5vvCBnrXydcfCRdhGWOxcQ/view?usp=share_link",
										"https://drive.google.com/file/d/1ZAoMOmcu5wyhq-317a5s21Kl8Y8Mr8Gg/view?usp=share_link"
									)}
								</AccordionDetails>
							</Accordion>

							<Accordion sx={{
								"&:hover": { backgroundColor: ColorScheme.secondary + ColorScheme.opacity90 },
							 }}>
								<AccordionSummary>
									{titleRow(
										t("user_manuals.tologo_charging"),
										1
									)}
								</AccordionSummary>
								<AccordionDetails>
									{linkRow(
										"https://drive.google.com/file/d/1dqWnOVtYmOp6P_VWpipdL8IhPv3I9HV2/view?usp=share_link",
										"https://drive.google.com/file/d/1ojFv3lEGCwQ0OmWKWxb7mRoFKONu7t7R/view?usp=share_link"
									)}
								</AccordionDetails>
							</Accordion>

							<Accordion sx={{
								"&:hover": { backgroundColor: ColorScheme.secondary + ColorScheme.opacity90 },
							 }}>
								<AccordionSummary>
									{titleRow(
										t("user_manuals.admin_introduction"),
										2
									)}
								</AccordionSummary>
								<AccordionDetails>
									{linkRow(
										"https://drive.google.com/file/d/1SLBd9mGbdyAYpm8CxPPhoA7IWmaOpoUK/view?usp=share_link",
										"https://drive.google.com/file/d/1UEwyECuLKbutD9bKV3UY-DAA-bFdFCIJ/view?usp=share_link"
									)}
								</AccordionDetails>
							</Accordion>

							<Accordion sx={{
								"&:hover": { backgroundColor: ColorScheme.secondary + ColorScheme.opacity90 },
							 }}>
								<AccordionSummary>
									{titleRow(
										t("user_manuals.admin_key_management"),
										2
									)}
								</AccordionSummary>
								<AccordionDetails>
									{linkRow(
										"https://drive.google.com/file/d/1y3OHiqmLorcYz8jjbTNRgbKZPbPG3GSA/view?usp=share_link",
										"https://drive.google.com/file/d/1_8qilUyXvTcdy_qHDM6XqY6c31_50EDk/view?usp=share_link"
									)}
								</AccordionDetails>
							</Accordion>

							<Accordion sx={{
								"&:hover": { backgroundColor: ColorScheme.secondary + ColorScheme.opacity90 },
							 }}>
								<AccordionSummary>
									{titleRow(
										t("user_manuals.admin_access"),
										2
									)}
								</AccordionSummary>
								<AccordionDetails>
									{linkRow(
										"https://drive.google.com/file/d/1cg8fsBBE0yk3lMCuh4zORc37AYptxufY/view?usp=share_link",
										"https://drive.google.com/file/d/1zM0_sQLAY6NqL6ncx7Z40q-DreS_cjgm/view?usp=share_link"
									)}
								</AccordionDetails>
							</Accordion>

							<Accordion sx={{
								"&:hover": { backgroundColor: ColorScheme.secondary + ColorScheme.opacity90 },
							 }}>
								<AccordionSummary>
									{titleRow(
										t("user_manuals.admin_charging"),
										2
									)}
								</AccordionSummary>
								<AccordionDetails>
									{linkRow(
										"https://drive.google.com/file/d/1Lh7YnSuBj7HQbugLz9OH1kCSBs83JGmW/view?usp=share_link",
										"https://drive.google.com/file/d/1waq0GNy0TsaJNQLxmU3qSgWyWE4E0FdD/view?usp=share_link"
									)}
								</AccordionDetails>
							</Accordion>
						</Stack>
						<Typography
							variant={"h5"}
							sx={{ marginBottom: "20px", marginTop: "50px" }}
						>
							{t("user_manuals.FAQ") + ":"}
						</Typography>
						<Stack>
							{q.map((question, index) => (
								<Accordion sx={{
								"&:hover": { backgroundColor: ColorScheme.secondary + ColorScheme.opacity90 },
							 }} key={index}>
									<AccordionSummary>
										<Typography sx={{ fontWeight: "700" }}>
											{question.question_fi}
										</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<Typography variant="p" fontSize={14}>
											{question.answer_fi}
										</Typography>
									</AccordionDetails>
								</Accordion>
							))}
						</Stack>
					</Stack>
				</LandingAnimation>
			)}
		</Box>
	);
};
